module.exports = __webpack_public_path__ + "img/qrcode.be88f6c1.jpg";